import React from 'react';
import { Modal, Button, Spinner, Table } from 'react-bootstrap';
import { formatoDecimal } from "../../../../utilities/formatoNumeros";

export default function ModalDetallePercepciones({ show, onHide, percepciones = [], isLoading }) {
    return (
        <Modal show={show} onHide={onHide} size="lg" centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Detalle de Percepciones</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {isLoading ? (
                    <div className="d-flex justify-content-center p-4">
                        <Spinner animation="border" variant="secondary" role="status">
                            <span className="visually-hidden">Cargando...</span>
                        </Spinner>
                    </div>
                ) : percepciones.length === 0 ? (
                    <div className="text-center p-3">
                        <strong>No hay percepciones disponibles</strong>
                    </div>
                ) : (
                    <div className="table-responsive">
                        <Table striped bordered hover responsive>
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Régimen</th>
                                    <th>Alícuota (%)</th>
                                    <th>Monto</th>
                                    <th>Monto a Devolver</th>
                                    <th>Saldo</th>
                                    <th>Base Imponible</th>
                                    <th>Provincia</th>
                                </tr>
                            </thead>
                            <tbody>
                                {percepciones.map((item, idx) => (
                                    <tr key={idx}>
                                        <td>{item.id}</td>
                                        <td>{item.regimen}</td>
                                        <td>{item.alicuota}</td>
                                        <td>${formatoDecimal(item.monto)}</td>
                                        <td>${formatoDecimal(item.montoADevolver)}</td>
                                        <td>${formatoDecimal(item.saldo)}</td>
                                        <td>${formatoDecimal(item.baseImponible)}</td>
                                        <td>{item.provincia ? item.provincia : "---"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <button
                    className="btn btn-sm background-rojo-megatone"
                    onClick={onHide}
                >
                    Cerrar
                </button>
            </Modal.Footer>
        </Modal>
    );
}
